import { useApiQuery } from './useApiQuery';
import { feeAccrualService } from '@/services/feeAccrualService';
import { queryKeys } from './queryKeys';
import type { FeeAccrualsResponse, Granularity } from '@/types/fee-accruals';

export const useFeeAccruals = (fundId: string, granularity: Granularity) => {
  return useApiQuery<FeeAccrualsResponse>(
    queryKeys.feeAccruals.list(fundId, granularity),
    () => feeAccrualService.getAccruals(fundId, granularity),
    {
      enabled: !!fundId,
    }
  );
};
